<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    if (!localStorage.cityNew) {
      localStorage.cityNew = JSON.stringify({})
    }
    window.onbeforeunload = function () {
      localStorage.go = ''
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.el-scrollbar__thumb {
    position: relative;
    display: block;
    width: 0;
    height: 0;
    cursor: pointer;
    border: 1px solid rgba(112, 160, 255, 0.6);
}

.el-range-editor--medium .el-range-separator {
    line-height: 28px;
    font-size: 14px;
    width: 80px;
}
.dialog .el-upload{
     width: 100px;
     height: 100px;
     padding: 10px;
     border: 1px dashed #d9d9d9 !important;
     display: flex;
     align-items: center;
     justify-content: center;
     img{
       width: 88px;
       height: 88px;
       display: flex !important;
     }
  }
  .avatar {
    width: 60px;
    height: 60px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
 .avatar1 {
    width: 60px;
    height: 60px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
